<template>
  <div id="site__wrapper">
    <div class="site__container">
      <app-nav></app-nav>
      <div class="site__right-column">
        <app-header></app-header>
        <router-view></router-view>
        <app-footer></app-footer>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import header from "./components/SiteHeader";
import nav from "./components/SiteNav";
import footer from "./components/SiteFooter";

export default {
  components: {
    "app-header": header,
    "app-nav": nav,
    "app-footer": footer
  }
};
</script>

<style lang="scss">
@use "../node_modules/normalize-scss/sass/normalize/variables";
@use "./assets/scss/_siteVariables" as *;

@media (prefers-color-scheme: light) {
  :root {
    --white: #ffffff;
    --black: #202124;
    --darkest-grey: #333333;
    --dark-grey: #666666;
    --mid-grey: #aaaaaa;
    --light-grey: #eeeeee;
    --lightest-grey: #f9f9f9;
    --accent: #008fff;
  }
}
@media (prefers-color-scheme: dark) {
  :root {
    --white: #202124;
    --black: #ffffff;
    --darkest-grey: #f9f9f9;
    --dark-grey: #eeeeee;
    --mid-grey: #aaaaaa;
    --light-grey: #666666;
    --lightest-grey: #333333;
    --accent: #008fff;
  }  
}

* {
  box-sizing: border-box;
}
//fixes content moving with scroll bar from page to page
html {
  -webkit-overflow-scrolling: touch;
  scroll-behavior: smooth;
  overflow-y: scroll;
}
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 16px;
  font-weight: normal;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.004);
  text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased !important;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-feature-settings: "kern" 1, "liga" 1;
  font-feature-settings: "kern" 1, "liga" 1;
  letter-spacing: -0.5px;
  background-color: var(--white);
  color: var(--black);
}
::selection {
  background: var(--light-grey); /* WebKit/Blink Browsers */
}
::-moz-selection {
  background: var(--light-grey); /* Gecko Browsers */
}
#site__wrapper {
  position: relative;
  overflow-x: hidden;
  width: 100%;
  // height: 100vh;
}
.active {
  .site__container {
    -webkit-transform: translateX(236px);
    transform: translateX(236px);
    -webkit-transform: translate3d(236px, 0, 0);
    transform: translate3d(236px, 0, 0);
  }
}
.site__container {
  margin: 0 auto;
  max-width: 1400px;
  width: 100%;
  display: flex;
  padding: 0 15px;
  //styles for off canvas mobile nav
  position: relative;
  -webkit-transform: translateX(0);
  transform: translateX(0);
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  -webkit-transition: 300ms ease all;
  transition: 300ms ease all;
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
}
.site__right-column {
  width: 100%;
  max-width: 1164px;
  @media only screen and (min-width: 1000px) {
    padding-left: 15px;
  }
}

//styles for speech bubbles throughout site
.speech-bubble {
  color: $white;
  background-color: $main-red;
  font-size: 55px;
  font-weight: bold;
  padding: 30px;
  position: relative;
  margin-bottom: 50px;
  flex-basis: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  @media only screen and (min-width: 1000px) {
    padding: 40px 30px;
  }
  &:after {
    content: "";
    width: 0;
    height: 0;
    border-left: 25px solid transparent;
    border-right: 25px solid transparent;
    border-top: 25px solid $main-red;
    position: absolute;
    bottom: -24px;
    left: 5%;
  }
  &__search-icon {
    width: 45px;
    height: 47px;
    margin-right: 15px;
  }
  &__search {
    border: none;
    background: transparent;
    color: var(--white);
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    transition: all 0.5s;
    width: 200px;
    font-weight: bold;
    &:focus {
      outline: none;
      width: 40%;
    }
    &::placeholder {
      color: var(--white);
    }
  }
  &--testimonial {
    justify-content: center;
    margin-top: 30px;
    flex-wrap: wrap;
    @media only screen and (min-width: 600px) {
      justify-content: flex-start;
      flex-wrap: nowrap;
    }
  }
  &__icon {
    min-width: 55px;
    height: 43px;
    @media only screen and (min-width: 600px) {
      margin-right: 30px;
    }
  }
  &__heading {
    font-size: 22px;
    word-break: break-all;
  }
  &__copy {
    font-size: 16px;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 10px;
    line-height: 1.5;
    letter-spacing: -0.3px;
  }
  &__copy-container {
    flex-basis: 100%;
    border-top: 2px solid $white;
    margin-top: 30px;
    @media only screen and (min-width: 600px) { 
      border-left: 2px solid $white;
      border-top: none;
      padding-left: 30px;
      margin-top: 0;
      flex-basis: auto;
    }
  }
  &--margin {
    margin-left: 15px;
    margin-right: 15px;
  }
}
</style>
